// Action Types
export const StatisticsActionTypes = {
  FETCH_START: 'STATISTICS_FETCH_START',
  FETCH_SUCCESS: 'STATISTICS_FETCH_SUCCESS',
  FETCH_ERROR: 'STATISTICS_FETCH_ERROR',
  SET_PERIOD_TYPE: 'STATISTICS_SET_PERIOD_TYPE',
  SET_DATE: 'STATISTICS_SET_DATE',
  RESET: 'STATISTICS_RESET',
} as const;

// Period Types
export type PeriodType = 'weekly' | 'monthly';

// API Response Types
export interface StatisticsPeriod {
  type: PeriodType;
  from: string; // YYYY-MM-DD
  to: string; // YYYY-MM-DD
}

export interface TrainingStatistics {
  total_users: number;
  with_band_users: number;
  without_band_users: number;
}

export interface DocumentStatistics {
  created: number;
  updated: number;
}

export interface InstitutionInfo {
  institution_sub: string;
  institution_id: string;
  institution_name: string;
  institution_email?: string;
  enabled: boolean;
}

export interface InstitutionStatistics {
  institution: InstitutionInfo;
  training: TrainingStatistics;
  moffraku_plans: DocumentStatistics;
  scientific_nursing_care: DocumentStatistics;
}

export interface AllInstitutionsStatisticsResponse {
  period: StatisticsPeriod;
  data: InstitutionStatistics[];
  total: number;
}

// Redux State Type
export interface StatisticsState {
  loading: boolean;
  error: string | null;
  periodType: PeriodType;
  date: string; // YYYY-MM-DD or YYYY-MM
  period: StatisticsPeriod | null;
  data: InstitutionStatistics[];
  total: number;
}

// Action Types
export type StatisticsAction =
  | { type: typeof StatisticsActionTypes.FETCH_START }
  | { type: typeof StatisticsActionTypes.FETCH_SUCCESS; payload: AllInstitutionsStatisticsResponse }
  | { type: typeof StatisticsActionTypes.FETCH_ERROR; error: string }
  | { type: typeof StatisticsActionTypes.SET_PERIOD_TYPE; payload: PeriodType }
  | { type: typeof StatisticsActionTypes.SET_DATE; payload: string }
  | { type: typeof StatisticsActionTypes.RESET };
